/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserMachineLicenseItem
 */
export interface MelcoModelsUserMachineLicenseItem {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserMachineLicenseItem
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserMachineLicenseItem
     */
    expires_on?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUserMachineLicenseItem
     */
    seconds_to_expire_utc?: number;
}

export function MelcoModelsUserMachineLicenseItemFromJSON(json: any): MelcoModelsUserMachineLicenseItem {
    return MelcoModelsUserMachineLicenseItemFromJSONTyped(json, false);
}

export function MelcoModelsUserMachineLicenseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserMachineLicenseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'expires_on': !exists(json, 'expires_on') ? undefined : (json['expires_on'] === null ? null : new Date(json['expires_on'])),
        'seconds_to_expire_utc': !exists(json, 'seconds_to_expire_utc') ? undefined : json['seconds_to_expire_utc'],
    };
}

export function MelcoModelsUserMachineLicenseItemToJSON(value?: MelcoModelsUserMachineLicenseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'expires_on': value.expires_on === undefined ? undefined : (value.expires_on === null ? null : value.expires_on.toISOString()),
        'seconds_to_expire_utc': value.seconds_to_expire_utc,
    };
}


